import { COLUMN_TYPE, isEnumColumn } from './columnTypes';

export class FilterEntry {
    constructor(type = COLUMN_TYPE.arbitrary) {
        this.type = type;
        this.model = isEnumColumn(type) ? [] : '';
    }

    doesMatch(value) {
        switch (this.type) {
            case COLUMN_TYPE.arbitrary:
                return ('' + value).toLowerCase().includes(('' + this.model).toLowerCase());

            case COLUMN_TYPE.enum:
            case COLUMN_TYPE.searchableEnum: {
                const selectedEnumEntries = this.model.filter(e => e.selected);

                if (selectedEnumEntries.length === 0) {
                    return true; // no selection - every item matches
                }
                const selectedEnumEntriesItems = selectedEnumEntries.map(e => e.item);

                if (Array.isArray(value)) {
                    return value.some(v => selectedEnumEntriesItems.includes(v));
                }

                return selectedEnumEntriesItems.includes(value);
            }
            case COLUMN_TYPE.dateTime:
            case COLUMN_TYPE.duration:
            case COLUMN_TYPE.number:
                return this.model.from <= value && this.model.to >= value;
        }

        console.error(`Missing type ${this.type}`); // eslint-disable-line

        return false;
    }

    isActive() {
        switch (this.type) {
            case COLUMN_TYPE.arbitrary:
                return this.model.length > 0;

            case COLUMN_TYPE.enum:
                return this.model.length !== this.model.filter(entry => entry.selected).length;

            default:
                return false;
        }
    }
}
